<template>
    <section>
        <div class="header-line grid-container">
            <div class="profile-label grid-item" data-qa="subscriptions-heading">
                Subscriptions
            </div>
        </div>
        <template lang="html">
            <div class="money-subscription-table">
                <ds-table-grid
                    :data="subscriptions"
                    align="center"
                    :sort-field="sortField"
                    :sort-ascending="sortAscending"
                    :click-row="editSubscriptionModal"
                    @sort="sortTable"
                >
                    <ds-table-grid-column
                        label="Subscription name"
                        width="150"
                    >
                        <template slot-scope="subscription">
                            <span :title="subscription.productName">
                                {{ modifyValidationMessage(subscription.productName) }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Quantity"
                        width="60"
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ subscription.quantity }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Start date"
                        width="90"
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ dateFormatDate(subscription.startDate, 'MMM D, YYYY') }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Bill amount"
                        width="90"
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ subscription.billingAmount }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Auto charge"
                        width="90"
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ subscription.autoCharge }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Status"
                        prop="subscriptionStatus"
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ subscription.status }}
                            </span>
                        </template>
                    </ds-table-grid-column>

                    <ds-table-grid-column
                        label="Cycle"
                        width="90"
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ subscription.billingCycle }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                    <ds-table-grid-column
                        label="Next bill"
                        width="90"
                        sortable
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ dateFormatDate(subscription.nextBillDate, 'MMM D, YYYY') }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                    <ds-table-grid-column
                        label="Credits"
                    >
                        <template slot-scope="subscription">
                            <span>
                                {{ subscription.credits }}
                            </span>
                        </template>
                    </ds-table-grid-column>
                </ds-table-grid>
            </div>
        </template>
    </section>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        subscriptions: Array,
        contact: Object,
    },

    data() {
        return {
            sortAscending: false,
            sortField: 'nextBillDate',
        };
    },

    methods: {
        dateFormatDate(date, format = 'll') {
            const formattedDate = moment(date).isValid() ? date : new Date(date);

            return moment(formattedDate).format(format);
        },

        modifyValidationMessage(message) {
            if (message && message.length > 25) {
                return `${message.slice(0, 25)}...`;
            }

            return message;
        },

        sortTable({ ascending }) {
            const factor = ascending === true ? -1 : 1;

            this.sortAscending = ascending;
            this.subscriptions = this.subscriptions.sort((prev, next) => {
                if (prev.nextBillDate > next.nextBillDate) return -1 * factor;
                if (prev.nextBillDate < next.nextBillDate) return 1 * factor;

                return 0;
            });
        },

        editSubscriptionModal(subscription) {
            window.open(`/JobRecurring/manageJobRecurring.jsp?view=edit&ID=${subscription.jobRecurringId}`);
        },
    },
};

</script>

<style lang="scss" scoped>
.header-line {
    display: flex;
}

.grid-container {
    display: flex;
    margin: $spacing-250 0;
}

.grid-item {
    margin: auto;
}

.profile-label {
    margin-left: 0;
    font-size: 1.75rem;
    color: $color-text;
}

.money-subscription-table {
    white-space: nowrap;
}

@media only screen and ($medium) {
    .grid-container {
        margin-top: 1.875rem;
        display: block;
    }
}
</style>
